/**
 * Created by Bart Decorte
 * Date: 13/09/2021
 * Time: 15:53
 */
const EventEmitter = require('events');

export default class UploadPreview extends EventEmitter {
  constructor(rootEl, { index = 0, file = undefined }) {
    super();
    this.baseProgress = 0.02;
    this.rootEl = rootEl;
    this.file = file;
    this.index = index;
    this.canceled = false;
    this.canceledPropagated = false;
    this.bindListeners();
  }

  async render() {
    if (! this.file) {
      // Pre-existing file, keep markup as-is
      return;
    }

    this.renderIndex();
    this.renderFilename();
    this.renderMiniatureAlt();
    this.renderMiniature();
  }

  bindListeners() {
    if (!this.btnClearEl()) {
      return;
    }

    this.btnClearEl().addEventListener('click', ev => this.lBtnClearClicked(ev));
  }

  lBtnClearClicked(ev) {
    ev.preventDefault();
    this.cancel();
  }

  progressWidth(progress) {
    return (this.baseProgress + (progress / (1 - this.baseProgress))) * 100; // in %
  }

  cancel() {
    this.canceled = true;
    this.clear();
    this.emitCancellation();
  }

  clear() {
    if (this.hasStoredData()) {
      this.btnDeleteEl().classList.remove('d-none');
    };
  }

  restore() {

  }

  emitCancellation() {
    // Only emit once, other classes might be keeping count of busy instances
    if (this.canceledPropagated) {
      return;
    }
    this.canceledPropagated = true;
    this.emit('canceled', { preview: this });
  }

  renderIndex() {
    this.rootEl.dataset.index = this.index;
  }

  renderFilename() {
    this.filenameEl().textContent = this.file.name;
  }

  renderMiniatureAlt() {

  }

  async renderMiniature() {

  }

  async miniatureSource() {
    const buffer = await this.readFile(this.file, 'ArrayBuffer');
    const orientation = await this.getOrientation(buffer);
    let dataUrl = await this.readFile(this.file, 'DataURL');

    return await this.transform(dataUrl, orientation, this.miniatureBoxWidth, this.miniatureBoxHeight);
  }

  async readFile(file, type) {
    return new Promise((resolve, reject) => {
      const fr = new FileReader();

      fr.onload = () => {
        resolve(fr.result);
      };

      fr['readAs' + type](file);
    })
  }

  // Ripped off from here: https://stackoverflow.com/a/32490603
  // -2: not jpeg
  // -1: not defined
  async getOrientation(buffer) {
    const view = new DataView(buffer);
    if (view.getUint16(0, false) != 0xffd8) {
      return -2;
    }

    const length = view.byteLength;

    let offset = 2;
    while (offset < length) {
      if (view.getUint16(offset + 2, false) <= 8) {
        return -1;
      }

      let marker = view.getUint16(offset, false);
      offset += 2;
      if (marker == 0xffe1) {
        if (view.getUint32((offset += 2), false) != 0x45786966) {
          return -1;
        }

        let little = view.getUint16((offset += 6), false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        let tags = view.getUint16(offset, little);
        offset += 2;
        for (let i = 0; i < tags; i++) {
          if (view.getUint16(offset + i * 12, little) == 0x0112) {
            return view.getUint16(offset + i * 12 + 8, little);
          }
        }
      } else if ((marker & 0xff00) != 0xff00) {
        break;
      } else {
        offset += view.getUint16(offset, false);
      }
    }
    return -1;
  }

  async transform(dataUrl, orientation, cropWidth, cropHeight) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const canvas = document.createElement('canvas');
      canvas.style.display = 'none';

      const rotations = {
        1: 0,
        2: 0,
        3: 180,
        4: 180,
        5: 90,
        6: 90,
        7: -90,
        8: -90,
      };

      img.onload = () => {
        const width = img.width;
        const height = img.height;

        let targetWidth;
        let targetHeight;
        if ([6, 8, 5, 7].indexOf(orientation) > -1) {
          targetWidth = height;
          targetHeight = width;
        } else {
          targetWidth = width;
          targetHeight = height;
        }

        let scale;
        if (targetWidth > targetHeight) {
          scale = cropHeight / targetHeight;
        } else {
          scale = cropWidth / targetWidth;
        }

        targetWidth *= scale;
        targetHeight *= scale;

        canvas.width = targetWidth;
        canvas.height = targetHeight;

        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        ctx.save();
        ctx.translate(targetWidth / 2, targetHeight / 2);
        ctx.rotate((rotations[orientation] * Math.PI) / 180);
        ctx.drawImage(img, -width / 2 * scale, -height / 2 * scale, targetWidth, targetHeight);
        ctx.restore();

        dataUrl = canvas.toDataURL('image/jpeg');
        document.body.removeChild(canvas);
        resolve(dataUrl);
      };
      img.setAttribute('src', dataUrl);
    });
  }

  filenameEl() {

  }

  miniatureEl() {

  }

  progressEl() {

  }

  btnClearEl() {

  }

  btnDeleteEl() {

  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/uploads/UploadPreview.js